import {BrowserRouter, Navigate, Outlet, Route, Routes} from "react-router-dom";
import Home from "./pages/Home/Home";
import Template from "./components/Template/Template";
import Dashboard from "./pages/Dashboard/Dashboard";
import Login from "./pages/Login/Login";
import {checkIsValidAuthenticated} from "./services/authService";

interface ProtectedRouteProps {
    authenticated?: boolean,
    roles?: string[],
    redirectPath?: string,
    goBack?: boolean
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = (props) => {
    let validAuth: boolean = false;
    if (props.authenticated) {
        let isAuth: boolean = checkIsValidAuthenticated();
        if (isAuth) {
            validAuth = true;
        } else {
            return <Navigate to={props.redirectPath != undefined ? props.redirectPath : "/login"} replace/>;
        }
    }

    if(validAuth) {
        return <Outlet/>;
    } else {
        return <Navigate to={props.redirectPath != undefined? props.redirectPath : "/login"} replace/>;
    }
}


export default function RoutesApp() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path={"/login"} element={<Login />}/>
                <Route element={<Template/>}>

                    <Route element={<ProtectedRoute authenticated={true} />}>
                        <Route path={"/"} element={<Home/>}/>
                        <Route path={"/dashboard"} element={<Dashboard/>} />
                    </Route>


                </Route>
            </Routes>
        </BrowserRouter>
    )
}